import React, {useEffect} from 'react';
import {zohoService} from "../../services/zohoServices";

function ZohoChatBot() {
    useEffect(() => {
        const getZohoSettings = async () => {
            try {
                const result = await zohoService.getZohoSettings()
                const {webKey} = result

                window.$zoho = window.$zoho || {};
                window.$zoho.salesiq = {
                    widgetcode: webKey,
                    values: {},
                    ready: function () {
                    }
                };

                const s = document.createElement('script');
                s.type = 'text/javascript';
                s.id = 'zsiqscript';
                s.defer = true;
                s.src = 'https://salesiq.zohopublic.com/widget';
                document.head.appendChild(s);

                const div = document.createElement('div');
                div.id = 'zsiqwidget';
                document.body.appendChild(div);
            } catch (e) {
                console.log(e)
            }
        }

        getZohoSettings()
    }, []);

    return true
}

export default ZohoChatBot;